import { parent } from "./index.module.css";
import React, { useState, useContext } from "react";
import { Context } from "../../store/store";
import { useHistory } from "react-router-dom";
import SpeechLib from "react-speech";

import Timer from "../../components/timer";
import Hero from "../../components/character";
import Button from "../../components/buttons/play";
import Tree from "../../components/buttons/tree";
import Speech from "../../components/speech";
import Pet from "../../components/pet";

import heroImgAro from '../../assets/Arouramain.png'
import heroImgSky from '../../assets/Sky1.png'
import bg from '../../assets/Step1.png'

export default function Index() {
	let history = useHistory();
	const test = useContext(Context);

	let decisionList = null;
	const [step, setStep] = useState(2);

	const [choice, setChoice] = useState("");
	const getChoice = (choice) => {
		setChoice(choice);
	};

	const next = () => {
		// console.log('NEXT!')
		// history.push("/test");
		if(step === 3){
			switch (choice) {
				case 'Custom Website':
					setStep(4)
					break;
				case 'Custom Website With Shopify APIs':
					
					setStep(5)
					break;
				case 'Shopify website builder':
					
					setStep(6)
					break;
				default:
					setStep(step + 1);
					break;
			}
		}else if(step >= 4){
			history.push("/scene3");
		}else if (step < decisionList.length - 1) {
			setStep(step + 1);
		}else{
			history.push("/scene3");
		}
	};

	const dialog1 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
				<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='left' pos={['280px','240px']} >
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="Now that we have decided to do an online store, we should decide on what platform to use. Should we build a customized website?
                    "
					/>
					Now that we have decided to do an online store, we should decide on
					what platform to use. Should we build a customized website?
				</Speech>
			</>
		);
	};

	const dialog2 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
        		<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='left' pos={['280px','240px']}>
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="That’s one option, but have you heard of Shopify? It’s a commerce platform that offers ways to either quickly launch a dream business solely on Shopify or utilizes its APIs to grant us creative freedom. 
                    "
					/>
					<Hero pos={["220px", "940px"]} img={heroImgSky} />
					That’s one option, but have you heard of Shopify? It’s a commerce
					platform that offers ways to either quickly launch a dream business
					solely on Shopify or utilizes its APIs to grant us creative freedom.
				</Speech>
			</>
		);
	};

	const dialog3 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
        		<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='right' pos={['150px','650px']} >
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="OOH I like the sound of that! Now between creating a customized website, with or without Shopify’s APIs, or using Shopify as a website builder, what would be best?"
					/>
					<Hero pos={["220px", "940px"]} img={heroImgSky} />OOH I like the sound of that! Now between creating a customized website, with or without Shopify’s APIs, or using Shopify as a website builder, what would be best?</Speech>
			</>
		);
	};

	const decision3 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
        		<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='right' pos={['150px','650px']} >
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="OOH I like the sound of that! Now between creating a customized website, with or without Shopify’s APIs, or using Shopify as a website builder, what would be best?"
					/>
					<Hero pos={["220px", "940px"]} img={heroImgSky} />OOH I like the sound of that! Now between creating a customized website, with or without Shopify’s APIs, or using Shopify as a website builder, what would be best?</Speech>
					      
				<Tree options={[
					'Custom Website',
					'Custom Website With Shopify APIs',
					'Shopify website builder'
					]} defaultOpt={1} func={getChoice}/>
			</>
		);
	};
	
	const option1 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
        		<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='right' pos={['150px','650px']} >
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="Suffering is good for the soul, right? Then let’s suffer and start from scratch!"
					/>
					<Hero pos={["220px", "940px"]} img={heroImgSky} />Suffering is good for the soul, right? Then let’s suffer and start from scratch!</Speech>
			</>
		);
	};

	
	const option2 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
        		<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='right' pos={['150px','650px']} >
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="Porque no los dos? (Why not both?) We’d get the best of both worlds!"
					/>
					<Hero pos={["220px", "940px"]} img={heroImgSky} />Porque no los dos? (Why not both?) We’d get the best of both worlds!</Speech>
			</>
		);
	};

	
	const option3 = () => {
		return (
			<>
				<Timer time={5} func={next} />
				<Hero pos={["315px", "10px"]} img={heroImgAro} />
        		<Hero pos={['220px','940px']} img={heroImgSky} />
				<Speech facing='right' pos={['150px','650px']} >
					<SpeechLib
						pitch="0.9"
						rate="0.9"
						volume="0.7"
						lang="en-GB"
						voice="Microsoft Zira - English (United States)"
						text="There’s no point to reinvent the wheel! Just this once, let it be easy. "
					/>
					<Hero pos={["220px", "940px"]} img={heroImgSky} />There’s no point to reinvent the wheel! Just this once, let it be easy. </Speech>
			</>
		);
	};

	decisionList = [
		dialog1,
		dialog2,
		dialog3,
		decision3,
		option1,
		option2,
		option3,
	];
	return (
		<div className={parent}>
			<div>
				<img src={bg} alt="" className='rounded' />
			</div>
    		{decisionList[step]()}
			<Pet pos={['580px',`1135px`]}/>
		</div>
	);
}
